var heading_default = {
  "fontElementMap": "Em0Cg",
  "elementSpacing": "uG9mM",
  "headerOne": "G0ngX uG9mM",
  "headerTwo": "VR2mg uG9mM",
  "headerThree": "srjtb uG9mM",
  "headerFour": "U16dQ uG9mM",
  "headerFive": "ABXRt uG9mM",
  "headerSix": "N-yY- uG9mM",
  "child": "OQArB"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
